import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

export default function CtaBand() {
  return (
    <section className="w-full px-4 py-16 md:px-8 md:py-24" aria-label="提交线索入口">
      <div className="relative mx-auto w-full max-w-7xl overflow-hidden rounded-lg bg-foreground-950">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20bokeh%20of%20city%20lights%20at%20night%20in%20deep%20gold%20and%20crimson%2C%20heavily%20blurred%20dark%20background%2C%20cinematic%20depth%20of%20field%2C%20moody%20editorial%20texture%2C%20no%20text%2C%20no%20people&width=1600&height=700&seq=baoliao51-cta-band-01&orientation=landscape"
          alt="爆料51 线索提交入口氛围背景"
          title="爆料51 线索提交 - 悬赏征集入口"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/75 to-foreground-950/55" />

        <div className="relative w-full px-6 py-14 md:px-14 md:py-20">
          <Reveal>
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.28em] text-accent-300">
                <span className="h-px w-6 bg-accent-300" />
                征集令 · 持续有效
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 text-balance md:text-4xl">
                你手里的那点信息，可能正是拼图的最后一块
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-background-200 md:text-base">
                无需实名，无需完整证据链。只要线索真实、方向明确，就可以提交给核实团队，由我们继续往下追。
              </p>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
                <Link
                  to="/submit"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-send-plane-line" />
                  前往提交线索
                </Link>
                <Link
                  to="/faq"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200/40 px-6 py-3 text-sm font-medium text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
                >
                  了解提交须知
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}